/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@angular-kit/core';

import { ViewInitializer } from '../view.initializer';
import { BaseDirective } from '../directive/base.directive';
import { ComponentDirective } from '../directive/component.directive';
import { ClickDirective } from '../directive/click.directive';
import { TagsDirective } from '../directive/tags.directive';
import { VisibleDirective } from '../directive/visible.directive';
import { TextDirective } from '../directive/text.directive';
import { TextComponent } from '../component/text/text.component';
import { LabelComponent } from '../component/label/label.component';
import { ImageDirective } from '../directive/image.directive';
import { ImageComponent } from '../component/image/image.component';
import { SvgComponent } from '../component/svg/svg.component';
import { ButtonComponent } from '../component/button/button.component';
import { LinkComponent } from '../component/link/link.component';
import { ContentComponent } from '../component/content/content.component';
import { ContainerComponent } from '../component/container/container.component';
import { ValueDirective } from '../directive/value.directive';
import { ValueComponent } from '../component/value/value.component';
import { TextInputDirective } from '../directive/text-input.directive';
import { TextInputComponent } from '../component/text-input/text-input.component';
import { TextAreaComponent } from '../component/text-area/text-area.component';
import { ValueLabelDirective } from '../directive/value-label.directive';
import { ValueLabelComponent } from '../component/value-label/value-label.component';
import { SelectInputComponent } from '../component/select-input/select-input.component';
import { ValueErrorDirective } from '../directive/value-error.directive';
import { ValueErrorComponent } from '../component/value-error/value-error.component';
import { FormFieldComponent } from '../component/form-field/form-field.component';
import { TableComponent } from '../component/table/table.component';
import { BackdropComponent } from '../component/backdrop/backdrop.component';
import { LoadIndicatorComponent } from '../component/load-indicator/load-indicator.component';
import { TemplateComponent } from '../component/template/template.component';
import { CheckboxInputDirective } from '../directive/checkbox-input.directive';
import { CheckboxComponent } from '../component/checkbox/checkbox.component';
import { TabsComponent } from '../component/tabs/tabs.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  declarations: [
    BaseDirective,
    ComponentDirective,
    ClickDirective,
    TagsDirective,
    VisibleDirective,
    TextDirective,
    ImageDirective,
    TextComponent,
    LabelComponent,
    ImageComponent,
    SvgComponent,
    ButtonComponent,
    LinkComponent,
    ContentComponent,
    ContainerComponent,
    ValueDirective,
    ValueComponent,
    TextInputDirective,
    TextInputComponent,
    TextAreaComponent,
    SelectInputComponent,
    ValueLabelDirective,
    ValueLabelComponent,
    ValueErrorDirective,
    ValueErrorComponent,
    FormFieldComponent,
    TableComponent,
    ImageDirective,
    BackdropComponent,
    LoadIndicatorComponent,
    TemplateComponent,
    CheckboxInputDirective,
    CheckboxComponent,
    TabsComponent
  ],
  entryComponents: [
    TextComponent,
    LabelComponent,
    ImageComponent,
    SvgComponent,
    ButtonComponent,
    LinkComponent,
    ContentComponent,
    ContainerComponent,
    ValueComponent,
    TextInputComponent,
    TextAreaComponent,
    SelectInputComponent,
    ValueLabelComponent,
    ValueErrorComponent,
    FormFieldComponent,
    TableComponent,
    BackdropComponent,
    LoadIndicatorComponent,
    TemplateComponent,
    CheckboxInputDirective,
    CheckboxComponent,
    TabsComponent
  ],
  providers: [],
  exports: [
    BaseDirective,
    ComponentDirective,
    ClickDirective,
    TagsDirective,
    VisibleDirective,
    TextDirective,
    TextComponent,
    LabelComponent,
    ImageDirective,
    ImageComponent,
    SvgComponent,
    ButtonComponent,
    LinkComponent,
    ContentComponent,
    ContainerComponent,
    ValueDirective,
    ValueComponent,
    TextInputDirective,
    TextInputComponent,
    TextAreaComponent,
    SelectInputComponent,
    ValueLabelDirective,
    ValueLabelComponent,
    ValueErrorDirective,
    ValueErrorComponent,
    FormFieldComponent,
    TableComponent,
    BackdropComponent,
    LoadIndicatorComponent,
    CheckboxInputDirective,
    CheckboxComponent,
    TabsComponent
  ]
})
export class ViewModule {

  constructor() {
    ViewInitializer.initialize();
  }

}
